import { Inject, Injectable, PLATFORM_ID, TemplateRef } from '@angular/core';
import { isPlatformBrowser } from '@angular/common';
import { ToastMessage } from '../../../models/database';

@Injectable({
  providedIn: 'root'
})
export class ToastService {

  toasts: ToastMessage[] = [];
  hasShownInitialToast: boolean = false;

  constructor(
    @Inject(PLATFORM_ID)
    private platformId: Object
  ) { }

  showToast(message: string, options: any = {}) {
      if(isPlatformBrowser(this.platformId)){
        this.toasts.push({ textOrTpl: message, options: { ...options, autohide: true, delay: 5000 } })
      }else {

      }
    }
    isTemplate(toast: ToastMessage): toast is { textOrTpl: TemplateRef<any> } {
      return toast.textOrTpl instanceof TemplateRef;
    }

    remove(toast: ToastMessage) {
      this.toasts = this.toasts.filter(t => t !== toast)
    }

    getToasts(){
      return this.toasts;
    }
  }
